var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoiCafe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#19456B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5576 34.5868L15.6945 19.6814H31.3212L29.458 34.5868H17.5576Z",
    stroke: "white",
    strokeWidth: 2.99169
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8636 11.4741C28.1217 9.9827 26.8636 9.23699 26.8636 9.23699C26.8636 9.23699 25.605 8.49128 26.8636 6.99985",
    stroke: "white",
    strokeWidth: 1.2964
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8636 15.9484C28.1217 14.4569 26.8636 13.7112 26.8636 13.7112C26.8636 13.7112 25.605 12.9655 26.8636 11.4741",
    stroke: "white",
    strokeWidth: 1.2964
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5076 11.4741C24.7658 9.9827 23.5076 9.23699 23.5076 9.23699C23.5076 9.23699 22.249 8.49128 23.5076 6.99985",
    stroke: "white",
    strokeWidth: 1.2964
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5076 15.9484C24.7658 14.4569 23.5076 13.7112 23.5076 13.7112C23.5076 13.7112 22.249 12.9655 23.5076 11.4741",
    stroke: "white",
    strokeWidth: 1.2964
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1521 11.4741C21.4103 9.9827 20.1521 9.23699 20.1521 9.23699C20.1521 9.23699 18.8936 8.49128 20.1521 6.99985",
    stroke: "white",
    strokeWidth: 1.2964
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1521 15.9484C21.4103 14.4569 20.1521 13.7112 20.1521 13.7112C20.1521 13.7112 18.8936 12.9655 20.1521 11.4741",
    stroke: "white",
    strokeWidth: 1.2964
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4442 21.2439C35.9176 21.415 37.2627 22.1644 38.1836 23.3272C39.1045 24.49 39.5257 25.9711 39.3547 27.4445C39.1836 28.9179 38.4342 30.263 37.2714 31.1839C36.1086 32.1048 34.6276 32.526 33.1541 32.355L33.4761 29.5821C34.2141 29.6678 34.9559 29.4568 35.5383 28.9955C36.1208 28.5343 36.4961 27.8605 36.5818 27.1225C36.6675 26.3845 36.4565 25.6427 35.9952 25.0603C35.534 24.4779 34.8602 24.1025 34.1222 24.0168L34.4442 21.2439Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoiCafe);
export default __webpack_public_path__ + "static/media/poi-cafe.39d90623e8308884c1cccbb1355437be.svg";
export { ForwardRef as ReactComponent };